// Wallpaper Calculator — Product Page Bootstrap
//
// Replaces the old dropdown-driven initializeCalculator() flow for the
// native product-page embed. Instead of a shopper picking a pattern from a
// list, this reads the current product's SKU (output by the Liquid snippet
// as a data attribute) and auto-selects the matching pattern from the CSV.
//
// If no matching pattern exists yet in the CSV (product not onboarded to
// the calculator), it falls back to a simple "request a quote" state
// instead of showing a broken or empty calculator.

document.addEventListener('DOMContentLoaded', async function () {
    const container = document.getElementById('wpCalcContainer');
    if (!container) return; // Snippet not present on this page — nothing to do

    const sku = (container.dataset.sku || '').trim();

    const loadingMessage = document.getElementById('loadingMessage');
    const errorMessage = document.getElementById('errorMessage');
    const calculatorForm = document.getElementById('calculatorForm');
    const noMatchEl = document.getElementById('wpCalcNoMatch');

    function showNoMatchState() {
        if (loadingMessage) loadingMessage.style.display = 'none';
        if (calculatorForm) calculatorForm.style.display = 'none';
        if (noMatchEl) noMatchEl.style.display = 'block';
    }

    if (!sku) {
        console.warn('⚠️ Wallpaper calculator: this product has no SKU metafield set.');
        showNoMatchState();
        return;
    }

    try {
        // Reuses loadPatternsFromCSV() from wp-calc-pattern-data.js (now with
        // sessionStorage caching, so this is only a real network fetch once
        // per browsing session, not once per product page).
        await loadPatternsFromCSV();

        const patternId = window.patternDataAPI.findPatternIdBySku(sku);

        if (!patternId) {
            console.log(`ℹ️ Wallpaper calculator: no CSV entry yet for SKU "${sku}".`);
            showNoMatchState();
            return;
        }

        // Auto-select the matched pattern — this is the direct replacement
        // for a shopper manually choosing from the old dropdown.
        window.calculatorAPI.selectPattern(patternId);

        if (loadingMessage) loadingMessage.style.display = 'none';
        if (calculatorForm) calculatorForm.style.display = 'block';

        wireUpCalculator();

    } catch (error) {
        console.error('❌ Wallpaper calculator failed to initialize:', error);
        showNoMatchState();
    }

    // Replicates the orchestration that used to live inline in index.html —
    // PDF generation, quote form, the Generate Preview button, and basic
    // input guardrails — minus anything dropdown- or iframe-specific.
    function wireUpCalculator() {
        if (typeof initializePDFGeneration === 'function') initializePDFGeneration();
        if (typeof initializeQuoteForm === 'function') initializeQuoteForm();

        const generateBtn = document.getElementById('generatePreviewBtn');
        if (generateBtn) {
            generateBtn.addEventListener('click', function () {
                generateBtn.disabled = true;
                generateBtn.textContent = 'Generating...';

                setTimeout(() => {
                    generatePreview().finally(() => {
                        generateBtn.disabled = false;
                        generateBtn.textContent = 'Generate Preview';

                        setTimeout(() => {
                            if (typeof addDownloadAndQuoteButtons === 'function') {
                                addDownloadAndQuoteButtons();
                            }
                        }, 300);
                    });
                }, 50);
            });
        }

        document.querySelectorAll('#calculatorForm input[type="number"]').forEach(function (input) {
            input.addEventListener('input', function () {
                const value = parseFloat(this.value);
                const min = parseFloat(this.min);
                const max = parseFloat(this.max);
                if (!isNaN(min) && value < min) this.value = min;
                if (!isNaN(max) && value > max) this.value = max;
            });
        });
    }
});